import CartTotalPrice from './CartTotalPrice';

export default CartTotalPrice;
